export const sortBy = (property) => {
	let sortOrder = 1;
	let prop = property;

	if (prop[0] === "-") {
		sortOrder = -1;
		prop = prop.substr(1);
	}

	return (a, b) => {
		// eslint-disable-next-line no-nested-ternary
		const result = a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0;
		return result * sortOrder;
	};
};

export const sortByMultiple = (...props) => {
	return (obj1, obj2) => {
		let i = 0;
		let result = 0;
		const numberOfProperties = props.length;

		while (result === 0 && i < numberOfProperties) {
			result = sortBy(props[i])(obj1, obj2);
			i += 1;
		}

		return result;
	};
};

export const groupBy = (collection, property) => {
	return collection.reduce((groups, item) => {
		const rowIndex = item[property] || 1;
		return {
			...groups,
			[rowIndex]: [...(groups[rowIndex] || []), item]
		};
	}, {});
};
